import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleDoubleDown, faAngleDoubleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Heading',
    props: {
        h1: { type: Boolean },
        h2: { type: Boolean },
        h3: { type: Boolean },
        h4: { type: Boolean },
        h5: { type: Boolean },
        h6: { type: Boolean },
        bold: { type: Boolean },
        separator: { type: Boolean },
        inline: { type: Boolean },
        size: { default: "lg" },
        icon: { default: "" },
        truncate: { type: Boolean },
        collapse: { default: "none" }
    },
    emits: ["click"],
    setup(__props) {
        const props = __props;
        library.add(faAngleDoubleDown, faAngleDoubleUp);
        const sizeClass = computed(() => {
            return `h-${props.size}`;
        });
        const collapsible = computed(() => {
            return props.collapse !== "none";
        });
        const collapsed = computed(() => {
            return props.collapse === "closed";
        });
        const element = computed(() => {
            for (const key of ["h1", "h2", "h3", "h4", "h5", "h6"]) {
                if (props[key]) {
                    return key;
                }
            }
            return "h1";
        });
        return { __sfc: true, props, sizeClass, collapsible, collapsed, element, faAngleDoubleDown, faAngleDoubleUp, FontAwesomeIcon };
    }
});
